export const signup = {
  transformYourFleetManagement: "Transform your Fleet Management",
  users: "1 User Account | {count} User Accounts",
  systems: "1 Connected Vehicle | {count} Connected Vehicles",
  days: "1 day | {count} days",
  unitMonth: "month",
  unitYear: "year",
  signUp: "Sign Up",
  signIn: "Sign In",
  freeAccountTips: `Get started today with a <span style="font-weight: bolder; color: #DE5E1B">Free Account</span> including`,
  unlimitedVehicleRegistration: "Unlimited Vehicle Registration",
  adminUserAccounts: "2 Administrator Accounts",
  GBPerConnectedVehicle: "1GB per Connected Vehicle",
  dashboardStatistics: "Dashboard Statistics",
  vehicleAndDriverManagement: "Vehicle and Driver Management",
  proAccountTips: `Upgrade to a <span style="font-weight: bolder; color: #5641F8">Pro Plan</span> to enjoy`,
  liveTracking: "Live Tracking",
  unlimitedVideoUploading: "Unlimited Video Uploading",
  digitizedInspectionReports: "Digitized Inspection Reports",
  driverFaceIDRegistration: "Driver Face ID Registration",
  geofencing: "Geofencing",
  andSoMuchMore: "And so much more…",
  AlreadyHaveAnAccount: "Already have an account?",
  saveBtnText: "Sign Up",
  failedToSignUp: "Sign up failed",
  signupErrorEmailCannotSignUpBeforeActive:
    "Unable to create a new CWorkX Connect Portal as you already have a pending portal creation with this email address. Please complete the validation process before creating a new one.",
  signupErrorDuplicateEmail: "This Email has been used.",
  signupErrorDuplicateCompanyName:
    "Sign up failed. This company name has already been used.",
  pleaseSelectARegion: "Please select a region.",
  pleaseSelectATimeZone: "Please select a time zone.",
  signUpNotification: "Sign Up Notification",
  signUpNotificationContent:
    "A notification has been sent to {email}. Click the link in the email to activate your account.",
  signupSuccessTips: "Your account was successfully verified. Please sign in.",
  signupEmailIsActivated:
    "Your account is already activated. Please sign in directly.",
  verifyFailed: "Activation Failed",
  verifyFailedContent: "Failed to activate your account. Please sign up again.",
  acceptServicesAndPrivacyPolicy: `
  I accept the <span class="via-text-link suf-link-text" data-type="TermsOfService"
  >terms of service</span> and <span class="via-text-link suf-link-text" data-type="PrivacyPolicy"
  >privacy policy</span>.`, // I accept the terms of service and privacy policy.
  signUpActivationExpired: `The activation link has expired. Failed to activate your account.`,
};
